import { parsePhoneNumberFromString } from 'libphonenumber-js'

/**
 * ISO country code (e.g. AU) from an E.164 or international phone string.
 */
export function resolveCountryFromPhone(phone) {
  if (!phone || typeof phone !== 'string') {
    return null
  }
  const trimmed = phone.trim()
  if (!trimmed) {
    return null
  }
  try {
    const parsed = parsePhoneNumberFromString(trimmed)
    return parsed && parsed.country ? parsed.country : null
  } catch (e) {
    return null
  }
}

/**
 * Persist vue-phone-number-input values in E.164 so country code survives reload.
 */
export function applyE164Phone(target, field, phonePayload) {
  if (!phonePayload) {
    return
  }
  if (phonePayload.e164) {
    target[field] = phonePayload.e164
    return
  }
  if (phonePayload.countryCallingCode && phonePayload.nationalNumber) {
    target[field] = `+${phonePayload.countryCallingCode}${phonePayload.nationalNumber}`
    return
  }
  if (phonePayload.formatInternational) {
    const compact = phonePayload.formatInternational.replace(/[^\d+]/g, '')
    if (compact.startsWith('+')) {
      target[field] = compact
    }
  }
}

/**
 * Apply owner + business phone payloads before API save.
 */
export function applyPhoneFieldsToBusiness(business, { phoneObject, businessPhoneObject }) {
  applyE164Phone(business, 'phone_number', phoneObject)
  applyE164Phone(business, 'business_phone', businessPhoneObject)
  if (phoneObject && phoneObject.countryCode) {
    business.phone_country_code = phoneObject.countryCode
  }
  if (businessPhoneObject && businessPhoneObject.countryCode) {
    business.business_phone_country_code = businessPhoneObject.countryCode
  }
}
